// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_EmployeeLastPeriodsBulkInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /payroll/employee_last_periods_bulk
 *
 * Validates input for bulk fetching last period end dates for multiple user+franchise combinations.
 */
import type { EmployeeFranchiseCombinationNestedInput } from './EmployeeFranchiseCombinationNestedInput'
import { registerContract } from './validate'

export interface Payroll_EmployeeLastPeriodsBulkInput {
combinations: EmployeeFranchiseCombinationNestedInput[]
}

registerContract('Payroll_EmployeeLastPeriodsBulkInput', {
  combinations: {
    type: 'array',
    required: true,
    items: {
      user_id:      { type: 'string',  required: true },
      franchise_id: { type: 'number',  required: true },
    },
  },
})
